import React from "react";
import Header from "./Header";
import PqrsdAdminDetail from "../pqrsd/PqrsdAdminDetail";

export default function LayoutPqrsdAdminDetail() {
  return (
    <>
      <Header />
      <PqrsdAdminDetail />
    </>
  );
}
